module.exports = __webpack_public_path__ + "img/xlm-coin.931a7a09.png";